import React from 'react'
import { Route, Routes } from 'react-router'
import asyncComponent from './hoc/asyncComponent/asyncComponent'

import './App.css'

const AsyncHome = asyncComponent(
  () => {
    return import('./component/home/home')
  },
  {
    title: 'Portfolio — Mostafa Izadloo',
    footer: true,
    navbar: true,
  }
)

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<AsyncHome />}></Route>
    </Routes>
  )
}

export default App
